<mat-list *ngIf="archivos.length > 0">
    <div mat-subheader *ngIf="archivos.length == 1">{{ 'section.dialogs.file'| translate}}</div>
    <div mat-subheader *ngIf="archivos.length > 1">{{ 'section.dialogs.files'| translate}}</div>
    <mat-list-item *ngFor="let archivo of archivos">
      <mat-icon mat-list-icon>article</mat-icon>
      <div mat-line>{{archivo.name}}</div>
      <div mat-line> {{(archivo.size/1000000) | number : '1.2-2'}} MB </div>
    </mat-list-item>
  </mat-list>
